import { useState } from 'react'
import { useClickOutside } from 'shared/hooks'
import type { Operator } from '../../types'
import { getOperatorDescription } from './getOperatorDescription'
import ModalOperator from './ModalOperator'
import { operators } from './operators.constants'
import { OperatorCurrentButton, OperatorsContainer } from './styles'

type OperatorsProps = {
  currentOperator: string
  type?: 'string' | 'array'
  handleChange?: (operator: Operator) => void
}

const Operators = ({
  currentOperator,
  type = 'string',
  handleChange
}: OperatorsProps) => {
  const [showModal, setShowModal] = useState(false)

  const onChange: OperatorsProps['handleChange'] = (operator) => {
    setShowModal(false)
    handleChange?.(operator)
  }

  const nodeRef = useClickOutside(() => {
    setShowModal(false)
  })

  return (
    <OperatorsContainer ref={nodeRef}>
      <OperatorCurrentButton
        type='button'
        onClick={() => setShowModal(!showModal)}
      >
        {getOperatorDescription(operators, type, currentOperator)}
      </OperatorCurrentButton>
      {showModal && (
        <ModalOperator operators={operators[type]} handleChange={onChange} />
      )}
    </OperatorsContainer>
  )
}

export default Operators
